module.exports = __webpack_public_path__ + "img/ic_publicity_detail2_2.1563e6c0.jpg";